import { render, staticRenderFns } from "./testpage.vue?vue&type=template&id=a56860a6&scoped=true"
import script from "./testpage.vue?vue&type=script&lang=js"
export * from "./testpage.vue?vue&type=script&lang=js"
import style0 from "./testpage.vue?vue&type=style&index=0&id=a56860a6&prod&lang=scss&scoped=true"
import style1 from "./testpage.vue?vue&type=style&index=1&id=a56860a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56860a6",
  null
  
)

export default component.exports